import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { IMembersGoogleScholarCandidate } from "./routeType";

const { key, getPath } = getApi("members.googleScholar.candidate.get");

type IExtractedRouteType =
  IMembersGoogleScholarCandidate["memberProfileSingleCandidateGoogleScholarDataCollectionRetrieve"];

export type IGetMemberGoogleScholarCandidate =
  IPickSingleQuery<IExtractedRouteType>;

const getMemberGoogleScholarCandidate: Fetcher<
  IGetMemberGoogleScholarCandidate["response"],
  IGetMemberGoogleScholarCandidate["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetMemberGoogleScholarCandidate = createQuery({
  queryKey: [key],
  fetcher: getMemberGoogleScholarCandidate,
});
